import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../Icon';
import { FeedbackListV4 } from '../FeedbackListV4';
import styles from './PlanLoaderProgressV6.css';

const STEPS = ['Reading your answers', 'Selecting your life chapters', 'Writing your first questions'];

function PlanLoaderProgressV6({ finish, heading = 'Building your Digital Memoir', steps = STEPS, reviews }) {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        if (progress === 100) {
            finish();

            return;
        }

        const timer = setTimeout(() => setProgress(prev => prev + 1), 100);

        return () => clearTimeout(timer);
    }, [progress]);

    const stepSize = 100 / steps.length;
    const currentStepIndex = Math.min(steps.length - 1, Math.floor(progress / stepSize));
    const visibleSteps = steps.slice(0, currentStepIndex + 1);

    const getStepPercent = index => {
        const min = index * stepSize;
        const max = (index + 1) * stepSize;

        if (progress <= min) return 0;
        if (progress >= max) return 100;

        return Math.round((progress - min) / (max - min) * 100);
    };

    return (
        <div className={styles.root}>
            <h1 className={styles.heading}>{heading}</h1>
            <div className={styles.steps}>
                {visibleSteps.map((step, index) => {
                    const isCompleted = index < currentStepIndex;

                    return (
                        <div className={styles.step} key={step}>
                            <div className={styles.stepRow}>
                                <span>{step}</span>
                                {isCompleted ? (
                                    <Icon name='checkItemFilled' className={styles.checkmark} />
                                ) : (
                                    <span>{getStepPercent(index)}%</span>
                                )}
                            </div>
                            {!isCompleted && (
                                <div className={styles.progressBarTrack}>
                                    <div className={styles.progressBarFill} style={{ width: `${getStepPercent(index)}%` }} />
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
            <div className={styles.reviews}>
                <FeedbackListV4 reviews={reviews} />
            </div>
        </div>
    );
}

PlanLoaderProgressV6.propTypes = {
    finish: PropTypes.func.isRequired,
    heading: PropTypes.string,
    steps: PropTypes.arrayOf(PropTypes.string),
    reviews: PropTypes.array
};

export {
    PlanLoaderProgressV6
};
